import { Component } from '@angular/core';
import { NavController, NavParams ,AlertController } from 'ionic-angular';
import {CartPage} from "../cart/cart";
import {CreateCustomerPage} from "../create-customer/create-customer";
import {EditCustomerPage} from "../edit-customer/edit-customer";

import {ItemsPage} from "../items/items";
import {Api} from "../../providers/api";
import {CartManager} from "../../providers/cart-manager";
import {ComingSoon} from "../coming-soon/coming-soon";
import {LoginPage} from "../login/login";
import {MsgManager} from "../../providers/msg-manager";
import { StockcartManager } from '../../providers/stockcart-manager';
import {GVLogger} from "../../services/gv-logger";

@Component({
  selector: 'page-list-customers',
  templateUrl: 'list-customers.html'
})
export class ListCustomersPage {
private showList: boolean;
private customers:any = [];
private searchQuery:any;



  constructor(public nav: NavController,
    public navParams: NavParams,
    public api:Api,
    private cartManager:CartManager,
    private alertCtrl:AlertController,
    private msgManager:MsgManager,
    private stockCartManager: StockcartManager,
    private gVLogger: GVLogger) {

    this.showList = true;
    //this.listCustomers();
    this.searchQuery = " ";
    this.searchCustomersLazy(this.searchQuery,0);
    // this.initializeCustomers();
  }

  ionViewDidLoad() {
    this.gVLogger.log('ionViewDidLoad ListCustomersPage');
  }
 // view cart
  goToCart() {
    this.nav.push(CartPage);
  }
 //  View goToCreateCustomer
   goToCreateCustomer(){
   this.nav.push(CreateCustomerPage);
   }

  // view a category
  viewCategory() {
    this.nav.push(ItemsPage);
  }

  searchCustomersLazy(searchQuery,itemCount){

    return new Promise(resolve=>{



  var url = "customers/searchAll/"+searchQuery+"/"+itemCount;
    this.gVLogger.log(url);
    // get list items of a category as sample
    this.api.get(url).map(res => res.json())
    .subscribe(data => {

      if(data.status == "401"){ // check for session out
          this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());
          resolve(true);
          this.nav.setRoot(LoginPage);
        }else if(data.status == "200"){
          let temp = this.customers;
          if(!(typeof data === 'undefined') && data){
              if (data.data && data.data.constructor === Array) {

              } else {
                data.data = [];
              }
            }else{
              data = { data: []};
            }
          for(let cust of data.data){
            //this.gVLogger.log(cust);
            temp.push(cust);
          }
          this.arrayUnique(temp);
          this.customers  = temp;



          // this.customers = this.customers.concat(data.data);
          //this.gVLogger.log(this.customers);
          resolve(true);
        }

      });

    });
}

searchThroughItems(ev: any){

    if(!ev){
      return false;
    }
    // Reset items back to all of the items
    // this.initializeCustomers();
    this.gVLogger.log(ev.target.value);
    // Show the results
    this.showList = true;
// set val to the value of the searchbar
    let val = ev.target.value;

    if(ev.target.value!=""){
      this.searchQuery = val;
      this.customers = [];
      this.searchCustomersLazy(this.searchQuery,0);
      }else{
        this.searchQuery = "";
        this.customers = [];
        this.searchCustomersLazy(this.searchQuery,0);
      }


    }

  onCancel(ev) {
    // Show the results
    this.showList = false;

    // Reset the field
    ev.target.value = '';
    this.searchQuery = "";
    this.customers = [];
    this.searchCustomersLazy(this.searchQuery,0);
  }


viewItemsList(customer){


  this.api.get("customers/"+ customer.id).map(res => res.json()).subscribe(result => {
    if(result.status == "200"){
      customer = result.data;

        let cartCustomerName = "  ";

        if(this.cartManager.getCustomerName()!= null){
          cartCustomerName = this.cartManager.getCustomerName();
        }

        if(this.cartManager.getProductsCount() > 0){

        let confirm = this.alertCtrl.create({
              title: 'Unsaved cart found.',
              message: "Customer: '"+ cartCustomerName +"'. What would you like to do?",
              buttons: [
                {
                  text: 'Go to old cart',
                  handler: () => {
                    this.nav.setRoot(CartPage);
                  }
                },
                {
                  text: 'Replace with new cart',
                  handler: () => {
                   this.cartManager.setCustomer(customer);
                   this.stockCartManager.setCustomer(customer);
                   this.nav.setRoot(ItemsPage);
                  }
                }
              ]
            });
            confirm.present();
        }else{
          this.cartManager.setCustomer(customer);
          this.stockCartManager.setCustomer(customer);
        //alert(JSON.stringify(customerId));
         this.nav.setRoot(ItemsPage);
        }
 }else if(result.status == "401"){ // check for session out
          this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());
          this.nav.setRoot(LoginPage);
        }
  });

}

// listCustomers(){

//   var rtApiURL = "customers/lazy/0";
//     this.gVLogger.log(rtApiURL);
//     // get list items of a category as sample
//     this.api.get(rtApiURL).map(res => res.json())
//     .subscribe(data => {
//       this.gVLogger.log(data.data);
//       // this.data = this.data.concat(data.data);
//        this.customers = data.data;
//       this.gVLogger.log(this.customers);

//       });
// }

editCustomer(customer){
  this.nav.push(EditCustomerPage,{"customerMinimized": customer});
}

doInfinite(infiniteScroll){
 this.searchCustomersLazy(this.searchQuery,this.customers.length).then(()=>{
   infiniteScroll.complete();
 });
}

arrayUnique(array) {
    var a = array.concat();
    for(var i=0; i<a.length; ++i) {
        for(var j=i+1; j<a.length; ++j) {
            if(a[i].id === a[j].id)
                a.splice(j--, 1);
        }
    }

    return a;
}


goToComingSoon(){
  // this.nav.push(ComingSoon);
  this.nav.push(CreateCustomerPage);
}








}



// WEBPACK FOOTER //
// ./src/pages/list-customers/list-customers.ts